import React from 'react'
import { StyledTabs } from 'components/TabsPaneStyles'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import { useState } from 'react'
import styled from 'styled-components'
import AgeFilter from './Partials/AgeFilter/AgeFilter'
import ArrearsFilter from './Partials/ArrearsFilter/ArrearsFilter'
import CollegeLocationFilter from './Partials/CollegeLocation/CollegeLocationFilter'
import DegreeDepartmentFilter from './Partials/DegreeDepartmentFilter'
import GenderFilter from './Partials/GenderFilter/GenderFilter'
import ScoreFilter from './Partials/ScoreFilter/ScoreFilter'
import SkillsFilter from './Partials/SkillFilter/SkillsFilter'
import StatusRoundFilter from './Partials/StatusRound/StatusRoundFilter'
import AssessmentStatusFilter from './Partials/AssessmentStatusFilter/AssessmentStatusFilter'
import WorkExperienceFilter from './Partials/workExperience/WorkExperienceFilter'
import YearFilter from './Partials/YearFilter/YearFilter'
import QualifyingQuestionFilter from './Partials/QualifyingQuestion/QualifyingQuestionFilter'
import CustomQuestionFilter from './Partials/CustomQuestion/CustomQuestionFilter'
import LocationFilter from './Partials/Location/LocationFilter'
import RoundsFilter from './Partials/RoundsFilter'
import AppliedDateFilter from './Partials/AppliedDate/AppliedDateFilter'
const ScheduleStatus = [
  {
    status: 'SCHEDULED',
  },
  {
    status: 'TO_BE_SCHEDULED',
  },
]
const RescheduleStatus = [
  {
    status: 'RESCHEDULED',
  },
  {
    status: 'RESCHEDULE',
  },
]
const StyledTab = styled(StyledTabs)`
  .ant-tabs-content {
    //height: 250px !important;

    overflow: ${props => (props?.overflow ? props?.overflow : 'scroll')};
    overflow-x: ${props => (props?.overflowX ? props?.overflowX : 'auto')};
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-tabs-nav {
    width: ${props => (props.width ? props?.width : '30%')} !important;
  }
  .ant-tabs-tab {
    padding: 15px !important;
  }
`
const IndividualDriveFilter = ({
  setSearchValue,
  rolesMetrics,
  setSearchParams,
  currentCount,
  totalCount,
  searchValue,
  setScorePayload,
  getCandidateList,
  setSelectedFilterValue,
  selectedFilterValue,
  filterOptions,
  filterValues,
  setFilterValues,
  handleFilterChange,
  handleFilterSearch,
  scoreFilterRef,
  onApplyFilters,
  isMenuOpen,
  setIsMenuOpen,
  data,
  setData,
  selectedQuickOption,
  setSelectedQuickOption,
  stage,
  showAssessmentStatusFilter
}) => {
  const onCancelFilter = async() => {
    setIsMenuOpen(!isMenuOpen)
    const dataSource = data?.map(item => {
      return {
        ...item,
        value: '',
      }
    })
    setData(dataSource)
    setScorePayload({})
    // Must stay an object — selectedFilterValue is sent as the request body on
    // subsequent sort/stage/tab refetches. An array here serialises to `[]` and
    // the backend rejects it with "body must be object" (FST_ERR_VALIDATION).
    setSelectedFilterValue({})
    setSelectedQuickOption(null)
     setFilterValues({
      selectedRound: [],
      selectedStatus: [],
      selectedDegrees: [],
      selectedDepartments: [],
      selectedSpecializations: [],
      selectedYears: [],
      selectedSkills: [],
      selectedColleges: [],
      selectedCollegeStates: [],
      selectedCollegeCities: [],
      selectedAge: {
        from: null,
        to: null,
      },
      selectedQuickAge: {
        from: null,
        to: null,
      },
      selectedGender: [],
      selectedScoreFilterType: '',
      selectedCurrentArrearFilterType: '',
      selectedPastArrearFilterType: '',
      selectScories: [],
      selectedCurrentArrearCount: null,
      selectedPastArrearCount: null,
      selectedPermanentState: [],
      selectedPermanentCity: [],
      selectedCurrentState: [],
      selectedCurrentCity: [],
      selectedPreferredLocation: [],
      selectedFunction: [],
      selectedRole: [],
      selectedDurationYear: [],
      selectedDurationMonth: [],
      selectedRoundScore: [],
      selectedQualifyingQuestions: [],
      selectedCustomQuestions: [],
      selectedAppliedDateRange: [],
      selectedAssessmentStatus: [],
      selectedRoundMode: true,
      includeArrears: false,
    })
   await getCandidateList({},0)
  }

  // Helper function to check if a filter category has active filters
  const hasActiveFilters = filterKeys => {
    return filterKeys.some(key => {
      const value = filterValues[key];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(
          v =>
            v !== null &&
            v !== '' &&
            v !== false &&
            v !== undefined
        );
      }

      return value !== null && value !== '' && value !== false;
    });
  };

  // Orange dot indicator component
  const FilterDot = () => (
    <span 
      style={{
        display: 'inline-block',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: '#FF8C00',
        marginLeft: '8px',
        verticalAlign: 'middle'
      }}
    />
  );

  const menu = [
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Round & Status</span>
          {hasActiveFilters(['selectedRound', 'selectedStatus']) && <FilterDot />}
        </span>
      ),
      key: '1',
      children: (
        <StatusRoundFilter
          filterOptions={filterOptions}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
          handleFilterSearch={handleFilterSearch}
          stage={stage}
        />
      ),
    },
    // Only present when the round being viewed has an assessment mapped to it.
    ...(showAssessmentStatusFilter
      ? [
          {
            label: (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <span>Assessment Status</span>
                {hasActiveFilters(['selectedAssessmentStatus']) && <FilterDot />}
              </span>
            ),
            key: '1c',
            children: (
              <AssessmentStatusFilter
                filterValues={filterValues}
                handleFilterChange={handleFilterChange}
              />
            ),
          },
        ]
      : []),
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Applied Date & Time</span>
          {hasActiveFilters(['selectedAppliedDateRange']) && <FilterDot />}
        </span>
      ),
      key: '1b',
      children: (
        <AppliedDateFilter
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Degree & Department</span>
          {hasActiveFilters(['selectedDegrees', 'selectedDepartments', 'selectedSpecializations']) && <FilterDot />}
        </span>
      ),
      key: '2',
      children: (
        <DegreeDepartmentFilter
          filterOptions={filterOptions}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
          handleFilterSearch={handleFilterSearch}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Year of passing</span>
          {hasActiveFilters(['selectedYears']) && <FilterDot />}
        </span>
      ),
      key: '3',
      children: (
        <YearFilter
          filterOptions={filterOptions}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
          handleFilterSearch={handleFilterSearch}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>College Name & Location</span>
          {hasActiveFilters(['selectedColleges', 'selectedCollegeStates', 'selectedCollegeCities']) && <FilterDot />}
        </span>
      ),
      key: '4',
      children: (
        <CollegeLocationFilter
        filterOptions={filterOptions}
        filterValues={filterValues}
        handleFilterSearch={handleFilterSearch}
        handleFilterChange={handleFilterChange}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Age</span>
          {hasActiveFilters(['selectedAge', 'selectedQuickAge']) && <FilterDot />}
        </span>
      ),
      key: '5',
      children: (
        <AgeFilter
          filterOptions={filterOptions}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
          setFilterValues={setFilterValues}
          selectedQuickOption={selectedQuickOption}
          setSelectedQuickOption={setSelectedQuickOption}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Gender</span>
          {hasActiveFilters(['selectedGender']) && <FilterDot />}
        </span>
      ),
      key: '6',
      children: (
        <GenderFilter
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>10th/12th/Graduation Scores</span>
          {hasActiveFilters(['selectedScoreFilterType', 'selectScories']) && <FilterDot />}
        </span>
      ),
      key: '7',
      children: (
        <ScoreFilter
          ref={scoreFilterRef}
          filterOptions={filterOptions}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          handleFilterChange={handleFilterChange}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Round Score</span>
          {hasActiveFilters(['selectedRoundScore']) && <FilterDot />}
        </span>
      ),
      key: '8',
      children: (
        <RoundsFilter
        filterOptions={filterOptions}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
          rolesMetrics={rolesMetrics}
          mode={filterValues?.selectedRoundMode}
          setMode={setFilterValues}
          data={data}
          setData={setData}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Arrears</span>
          {hasActiveFilters(['selectedCurrentArrearFilterType', 'selectedPastArrearFilterType', 'selectedCurrentArrearCount', 'selectedPastArrearCount', 'includeArrears']) && <FilterDot />}
        </span>
      ),
      key: '9',
      children: (
        <ArrearsFilter
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          handleFilterChange={handleFilterChange}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Skills</span>
          {hasActiveFilters(['selectedSkills']) && <FilterDot />}
        </span>
      ),
      key: '10',
      children: (
        <SkillsFilter
          filterOptions={filterOptions}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
          handleFilterSearch={handleFilterSearch}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Qualifying Questions</span>
          {hasActiveFilters(['selectedQualifyingQuestions']) && <FilterDot />}
        </span>
      ),
      key: '11',
      children: (
        <QualifyingQuestionFilter
        filterOptions={filterOptions}
        filterValues={filterValues}
        handleFilterChange={handleFilterChange}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Custom Questions</span>
          {hasActiveFilters(['selectedCustomQuestions']) && <FilterDot />}
        </span>
      ),
      key: '11a',
      children: (
        <CustomQuestionFilter
          filterOptions={filterOptions}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Location</span>
          {hasActiveFilters(['selectedPermanentState', 'selectedPermanentCity', 'selectedCurrentState', 'selectedCurrentCity', 'selectedPreferredLocation']) && <FilterDot />}
        </span>
      ),
      key: '12',
      children: (
        <LocationFilter
        filterOptions={filterOptions}
        filterValues={filterValues}
        handleFilterChange={handleFilterChange}
        handleFilterSearch={handleFilterSearch}
        />
      ),
    },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>Work Experience</span>
          {hasActiveFilters(['selectedFunction', 'selectedRole', 'selectedDurationYear', 'selectedDurationMonth']) && <FilterDot />}
        </span>
      ),
      key: '13',
      children: (
        <WorkExperienceFilter
          filterOptions={filterOptions}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
          handleFilterSearch={handleFilterSearch}
        />
      ),
    },
  ]

  return (
    <TableSearchFilter
      setSearchValue={setSearchValue}
      searchValue={searchValue}
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
      currentCount={currentCount}
      totalCount={totalCount}
      CandidateFilter={false}
      onApplyFilter={onApplyFilters}
      onCancelFilter={onCancelFilter}
      name="EvaluationProcess"
    />
  )
}

export default IndividualDriveFilter
